import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Paper,
    Typography,
    Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

interface Props {
    open: boolean;
    conflictDataCount: number;
    onClose?: () => void;
}

/**
 * 数据冲突提示对话框
 * 当检测到本地数据与服务器数据不一致时显示
 */
export const DataConflictModals: React.FC<Props> = ({
    open,
    conflictDataCount,
    onClose
}) => {
    const navigate = useNavigate();

    const handleResolve = () => {
        if (onClose) {
            onClose();
        }
        navigate("/bag-list");
    };

    const handleDismiss = () => {
        if (onClose) {
            onClose();
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleDismiss}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    p: "18px",
                    borderRadius: "12px",
                }
            }}
        >
            <Box
                sx={{
                    p: "18px",
                    borderRadius: "12px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                }}
            >
                <Typography
                    sx={{
                        color: "#FF2626",
                        fontSize: "18px",
                        fontWeight: "500"
                    }}
                >
                    數據衝突
                </Typography>
                <Typography>
                    系統檢測到{conflictDataCount}個旗袋的狀態與服務器紀錄不符。這可能是因為該旗袋已在另一台設備上被更新。請立即審查並解決這些衝突，以確保數據準確。
                </Typography>
            </Box>

            <DialogActions sx={{ py: "6px" }}>
                <Button
                    onClick={handleResolve}
                    variant="contained"
                    color="error"
                    autoFocus
                    fullWidth
                    sx={{
                        borderRadius: "6px",
                        bgcolor: "#FF2626",
                    }}
                >
                    <Typography>
                        立即解決
                    </Typography>
                </Button>
            </DialogActions>
        </Dialog>
    );
};